export default __webpack_public_path__ + "static/media/krefeld_light.b3744681.png";